"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const react_inspector_1 = require("react-inspector");
const ui_1 = require("react-science/ui");
const ChartContext_1 = require("../../context/ChartContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const Button_1 = __importDefault(require("../../elements/Button"));
const ColumnWrapper_1 = require("../../elements/ColumnWrapper");
const ReactTable_1 = __importDefault(require("../../elements/ReactTable/ReactTable"));
const Alert_1 = require("../../elements/popup/Alert");
const Modal_1 = require("../../elements/popup/Modal");
const useSpectraPerNucleus_1 = __importDefault(require("../../hooks/useSpectraPerNucleus"));
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const rowColors = {
    active: {
        base: {
            backgroundColor: '#707070',
            color: 'white',
        },
    },
    deActive: {
        base: {
            opacity: 0.2,
        },
        activated: {
            opacity: 1,
        },
    },
};
function FiltersTableInner({ filters, spectraCounter, activeFilterID, }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const alert = (0, Alert_1.useAlert)();
    const selectedFilterIndex = (0, react_1.useRef)();
    const handelFilterCheck = (0, react_1.useCallback)((id, enabled) => {
        void (async () => {
            const hideLoading = await alert.showLoading(`${enabled ? 'Enable' : 'Disable'} filter in progress`);
            setTimeout(() => {
                dispatch({ type: 'ENABLE_FILTER', payload: { id, enabled } });
                hideLoading();
            }, 0);
        })();
    }, [alert, dispatch]);
    const handelDeleteFilter = (0, react_1.useCallback)(({ id, name, label }) => {
        const buttons = [
            {
                text: 'Yes',
                handler: async () => {
                    const hideLoading = await alert.showLoading('Delete filter process in progress');
                    dispatch({ type: 'DELETE_FILTER', payload: { id } });
                    hideLoading();
                },
            },
            { text: 'No' },
        ];
        if (spectraCounter > 1) {
            buttons.unshift({
                text: 'Yes, for all spectra',
                handler: async () => {
                    const hideLoading = await alert.showLoading('Delete all spectra filter process in progress');
                    dispatch({
                        type: 'DELETE_SPECTRA_FILTER',
                        payload: { filterName: name },
                    });
                    hideLoading();
                },
            });
        }
        modal.showConfirmDialog({
            message: ((0, jsx_runtime_1.jsxs)("span", { children: ["You are about to delete this processing step", (0, jsx_runtime_1.jsxs)("span", { style: { color: 'black' }, children: [" ", label, " "] }), " , Are you sure?"] })),
            buttons,
        });
    }, [alert, dispatch, modal, spectraCounter]);
    const filterSnapShotHandler = (0, react_1.useCallback)((filter, index) => {
        selectedFilterIndex.current =
            selectedFilterIndex.current && index === selectedFilterIndex.current
                ? null
                : index;
        void (async () => {
            const hideLoading = await alert.showLoading('Filter snapshot process in progress');
            setTimeout(() => {
                dispatch({ type: 'SET_FILTER_SNAPSHOT', payload: filter });
                hideLoading();
            }, 0);
        })();
    }, [alert, dispatch]);
    const COLUMNS = (0, react_1.useMemo)(() => [
        {
            Header: '#',
            style: { width: '25px' },
            accessor: (_, index) => index + 1,
            disableSortBy: true,
        },
        {
            Header: 'Label',
            accessor: 'label',
            disableSortBy: true,
        },
        {
            Header: 'Properties',
            Cell: ({ row }) => {
                const { error, value } = row.original;
                return ((0, jsx_runtime_1.jsxs)(ColumnWrapper_1.ColumnWrapper, { children: [(0, jsx_runtime_1.jsx)(react_inspector_1.ObjectInspector, { data: error || value }), ' '] }));
            },
        },
        {
            Header: 'Enable',
            style: { width: '30px' },
            Cell: ({ row }) => {
                const { flag, id } = row.original;
                return ((0, jsx_runtime_1.jsx)(ColumnWrapper_1.ColumnWrapper, { children: (0, jsx_runtime_1.jsx)(ui_1.Checkbox, { onChange: (checked) => handelFilterCheck(id, checked), checked: flag }) }));
            },
        },
        {
            Header: '',
            style: { width: '20px' },
            id: 'delete-button',
            Cell: ({ row }) => {
                const { isDeleteAllow } = row.original;
                return ((0, jsx_runtime_1.jsx)(ColumnWrapper_1.ColumnWrapper, { children: (0, jsx_runtime_1.jsx)(Button_1.default.Danger, { fill: "outline", onClick: () => handelDeleteFilter(row.original), disabled: !isDeleteAllow, children: (0, jsx_runtime_1.jsx)(fa_1.FaRegTrashAlt, {}) }) }));
            },
        },
    ], [handelDeleteFilter, handelFilterCheck]);
    function handleRowStyle(data) {
        const { original, index } = data;
        const { id } = original;
        if (activeFilterID) {
            if (activeFilterID === id) {
                return rowColors.active;
            }
            else if (selectedFilterIndex.current &&
                index > selectedFilterIndex.current) {
                return rowColors.deActive;
            }
        }
    }
    return ((0, jsx_runtime_1.jsx)(ReactTable_1.default, { rowStyle: handleRowStyle, data: filters, columns: COLUMNS, emptyDataRowText: "No Filters", onClick: (e, data) => filterSnapShotHandler(data.original, data.index) }));
}
const emptyData = { filters: [] };
const MemoizedFiltersTable = (0, react_1.memo)(FiltersTableInner);
function FilterTable() {
    const { toolOptions: { data: { activeFilterID }, }, } = (0, ChartContext_1.useChartData)();
    const { filters } = (0, useSpectrum_1.default)(emptyData);
    const spectraCounter = (0, useSpectraPerNucleus_1.default)().length;
    return ((0, jsx_runtime_1.jsx)(MemoizedFiltersTable, { filters, spectraCounter, activeFilterID }));
}
exports.default = FilterTable;
